import React, {
  createContext,
  Fragment,
  useContext,
  useEffect,
  useState,
} from "react";
import { Login } from "./area/home/component/Login";
import "./App.css";
import OandoLogo from "../src/area/home/component/images/logo2.png";
import expirysvg from "../src/area/home/component/images/contract.svg";
import {
  Routes,
  Route,
  Link,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { Layout, Button, Result, Menu, notification, Tooltip } from "antd";
import {
  MessageBar,
  ProgressIndicator,
  MessageBarType,
} from "@fluentui/react";
import Text from "antd/lib/typography/Text";

import { DatabaseOutlined, MenuOutlined, ApiOutlined } from "@ant-design/icons";
import { North } from "./area/home/component/region/North";
import { Observer, observer } from "mobx-react-lite";
import MainStore from "../src/area/home/store/mainStore";
import ProfileStore from "../src/area/userprofile/store/profilestore";
import SubMenu from "antd/lib/menu/SubMenu";
import {
  getAntIconEquivalent,
  getCurrentUser,
  getPermissions,
  setCurrentUser,
  setDefaultMenuOpenkey,
} from "./Utility/modules/helpers";

import { PageContainerHOC } from "./Utility/modules/PageContainerHOC";

//Pages
import { UserProfileBaseView } from "./area/userprofile/components/UserProfileBaseView";
import { AccountCenterBaseView } from "../src/area/admin/accountcenter/components/AccountCenterBaseView";
import { PermissionBaseView } from "../src/area/admin/permission/component/PermissionBaseView";
import { FieldDailyProductionBaseView } from "../src/area/productiondata/FieldDailyProductionBaseView";
import { ProductionTargetBaseView } from "../src/area/productiontarget/ProductionTargetBaseView";
import { SettingsBaseView } from "../src/area/settings/SettingsBaseView";
import { Contract } from "./area/productiontarget/Contract";

import Media from "react-media";
import { Offline } from "react-detect-offline";

import { ReportViewer } from "./shared/ReportViewer";
import { MaterialBaseView } from "./area/materials/MaterialBaseView";
import { MonthlyPerformanceBaseView } from "./area/monthly-performance/MonthlyPerformanceBaseView";
import { VisualQueryBuilder } from "./area/monthly-performance/VisualQueryBuilder";

import { FlowStationVisualizationBaseView } from "./area/visualizations/performance/flowstation-performance/FlowStationVisualizationBaseView";
import { RequestBaseView } from "./area/productiondata/approvals/RequestBaseView";
import { ApprovalBaseView } from "./area/productiondata/approvals/ApprovalBaseView";

import { HighLightBaseView } from "./area/productiondata/highlight/HighLightBaseView";
import { GlobalLinkBaseView } from "./area/home/component/global-links/GlobalLinkBaseView";
import { ProductionDashboardContainer } from "./area/visualizations/Production/ProductionDashboardContainer";
import { WellPerformanceBaseView } from "./area/visualizations/wellperformance/WellPerformanceBaseView";
import { FlowStationprodTrendBaseView } from "./area/visualizations/performance/flowstation-production-trend/FlowStationprodTrendBaseView";
import { FieldprodTrendBaseView } from "./area/visualizations/performance/field-production-trend/FieldprodTrendBaseView";

const { Header, Content, Footer, Sider } = Layout;
//wrap page to HOC

///PAGE scafoLLDS/////
const _ = require("underscore");
const userProfileBaseView = PageContainerHOC(UserProfileBaseView);
const accountCenterView = PageContainerHOC(AccountCenterBaseView);
const permissionView = PageContainerHOC(PermissionBaseView);
const fieldDailyProductionView = PageContainerHOC(FieldDailyProductionBaseView);
const productionTargetBaseView = PageContainerHOC(ProductionTargetBaseView);
const materialBaseView = PageContainerHOC(MaterialBaseView);
const settingsBaseView = PageContainerHOC(SettingsBaseView);
const contractBaseView = PageContainerHOC(Contract);
const monthlyPerformanceBaseView = PageContainerHOC(MonthlyPerformanceBaseView);
const visualQueryBuilderView = PageContainerHOC(VisualQueryBuilder);

const wellperformance = PageContainerHOC(WellPerformanceBaseView);
const flowStationVisualizationBaseView = PageContainerHOC(
  FlowStationVisualizationBaseView
);
const flowStationprodTrendBaseView = PageContainerHOC(
  FlowStationprodTrendBaseView
);
const fieldProdTrendBaseView = PageContainerHOC(FieldprodTrendBaseView);
const requestBaseView = PageContainerHOC(RequestBaseView);
const approvalBaseView = PageContainerHOC(ApprovalBaseView);
const highLightBaseView = PageContainerHOC(HighLightBaseView);
const outlookDashboard = PageContainerHOC(ProductionDashboardContainer);

let globalHistory = {};
////////////////////////////////////////////////////////////////////////////////////////////
const mainstore = createContext(MainStore);
export const NotFound = ({ ...rest }) => {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={<Button type="primary">Back Home</Button>}
    />
  );
};
export const Expiry = ({ ...rest }) => {
  return (
    <div className="ms-Grid" dir="ltr">
      <div
        className="ms-Grid-row"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "90vh",
          backgroundColor: "white",
        }}
      >
        <div
          className="ms-Grid-col ms-sm12 ms-md6 ms-lg6"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={expirysvg} alt="" />
        </div>
        <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
          {" "}
          <Result
            title={
              <span style={{ color: "red" }}>
                SPARS Enterprise Licence Subscription has Expired
              </span>
            }
            extra={
              <Button
                type="primary"
                htmlType="button"
                key="console"
                href="mailto:projects@cybersprint.tech"
              >
                Renew SPARS licence
              </Button>
            }
          />
        </div>
      </div>
    </div>
  );
};
export const App = observer((props) => {
  const currentUser = getCurrentUser();
  const mainStore = useContext(mainstore);
  const profileStore = useContext(ProfileStore);

  const collapseNavBar =
    currentUser?.userPreference?.isNavbarCollapsed || false;
  const [state, setState] = useState({
    collapsed: collapseNavBar,
    isLoading: false,
    menuData: [],
    clearselection: false,
  });

  let brandPix = OandoLogo;
  /*  if (window.location.hostname === "localhost") {
    brandPix = shellBrand;
  } */

  useEffect(() => {
    const fetchApplicationMenu = async () => {
      try {
        const menu = await mainStore.fetchAppMenu();
        await mainStore.fetchAssets();
        window.appMenu = menu;
        setState({ ...state, menuData: menu });
        mainStore.ismenuLoading = false;
      } catch (error) {
        if (!error.response) {
          notification.error({
            key: "error",
            message: "SPARS Feedback",
            description:
              "SPARS Backend Server is not reachable, please contact SPARS support",
          });
        } else {
          notification.error({
            key: "error",
            message: "SPARS Feedback",
            description: error.message,
          });
        }
      }
    };
    fetchApplicationMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const NoAccess = () => {
    const navigate = useNavigate();

    return (
      <Result
        status="403"
        title="Access Denied"
        subTitle="Sorry, you are not authorized to access this page. Contact SPARS admin to request for access"
        extra={
          <div>
            <Button
              type="danger"
              onClick={(ev) => {
                navigate(-1);
              }}
            >
              Go Back
            </Button>
            <Button
              type="primary"
              onClick={(ev) => {
                navigate("/dashboard/production-outlook");
              }}
              style={{ marginLeft: "20px" }}
            >
              Go to Dashboard
            </Button>
          </div>
        }
      />
    );
  };

  const PrivateRoute = ({ component: Component }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const permission = getPermissions(location.pathname);
    const legacyProps = {
      location,
      history: {
        goBack: () => navigate(-1),
        push: navigate,
      },
      match: {
        url: location.pathname,
        path: location.pathname,
        params: {},
      },
    };

    if (!currentUser) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return permission.canView ? (
      <Component {...legacyProps} permission={permission} />
    ) : (
      <NoAccess />
    );
  };

  const onCollapse = async (collapsed) => {
    try {
      setState({ ...state, collapsed });

      let currentUser = getCurrentUser();
      if (currentUser) {
        await profileStore.setUserNavigationPreference(
          currentUser?.id,
          collapsed
        );
        if (currentUser.userPreference) {
          currentUser.userPreference.isNavbarCollapsed = collapsed;
          setCurrentUser(currentUser);
        }
      }
    } catch (error) {
      notification.error({
        message: "SPARS Feedback",
        description: error.message,
      });
    }
  };

  const handleClearMenuSelection = () => {
    setState({ ...state, clearselection: true });
  };
  const subMenuClick = async (smId, mId) => {
    try {
      setState({ ...state, clearselection: false });
      await profileStore.setUserLastVisitedUrl(window.location.pathname, mId);
      setDefaultMenuOpenkey(mId);
    } catch (error) {
      notification.error({
        message: "SPARS Feedback",
        description: error.response && error.response.text,
      });
    }
  };
  //const openkey = getDefaultMenuOpenkey()?.toString();

  //menuSelectedKey = selectMenu(window.location.pathname);
  const sideMenus = _.where(state.menuData, { menuType: 1 }).map((menu) => (
    <SubMenu
      title={
        <span>
          {getAntIconEquivalent(menu.menuIcon, state?.collapsed ?? false)}
          <Text style={{ color: "inherit" }}>{menu.menu}</Text>
        </span>
      }
      key={menu.menuId}
    >
      {menu.subMenus.map((sm) => (
        <Menu.Item
          key={sm.subMenuId}
          style={{ cursor: "pointer" }}
          onClick={async () => {
            await subMenuClick(sm.subMenuId, menu.menuId);
          }}
        >
          <Link to={sm.url ? sm.url : "#"}>{sm.name}</Link>
        </Menu.Item>
      ))}
    </SubMenu>
  ));

  const globalMenu = _.where(state.menuData, { menuType: 2 });

  // Check if user is on login page
  const location = useLocation();
  const isLoginPage = location.pathname === "/" || location.pathname === "/login";

  if (isLoginPage) {
    return <Login />;
  }

  return (
    <>
      <Media
        query={{ minWidth: 1300 }}
        onChange={(val) => {
          if (!val) {
            onCollapse(true);
          } else {
            onCollapse(false);
          }
        }}
      />
          <Layout style={{ minHeight: "100vh" }}>
            <Sider
              collapsible
              collapsed={state.collapsed}
              onCollapse={onCollapse}
              width={300}
            >
              <div className="logo" />

              <div className="ms-Grid" dir="ltr">
                {state.collapsed && (
                  <div className="ms-Grid" dir="ltr" style={{ padding: "0px" }}>
                    <div
                      className="ms-Grid-col ms-sm12"
                      style={{
                        paddingTop: "10px",
                        marginBottom: "5px",

                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <img src={brandPix} alt="Oand logo"></img>
                    </div>
                    <div className="ms-Grid-row">
                      <div
                        className="ms-Grid-col ms-sm12"
                        style={{ color: "white", fontWeight: "bold" }}
                      >
                        SPARS
                      </div>
                    </div>
                  </div>
                )}
                {!state.collapsed && (
                  <div className="ms-Grid-row" style={{ paddingTop: "10px" }}>
                    <div className="ms-Grid-col ms-sm2">
                      <img src={brandPix} alt="Oand logo"></img>
                    </div>
                    <div className="ms-Grid-col ms-sm7">
                      <div className="QikReach">
                        <h1 className="profoioh1">SPARS</h1>
                      </div>
                    </div>
                    <div
                      className="ms-Grid-col ms-sm3"
                      style={{
                        verticalAlign: "bottom",
                      }}
                    >
                      <span style={{ color: "#F6AD55", fontSize: "12px" }}>
                        R2026.1.113
                      </span>
                    </div>
                  </div>
                )}

                {!state.collapsed && (
                  <div className="ms-Grid-row">
                    <div
                      className="ms-Grid-col ms-sm12 "
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Text
                        style={{
                          color: "white",
                        }}
                      >
                        <MenuOutlined /> Menu
                      </Text>
                    </div>
                  </div>
                )}
              </div>
              {mainStore.ismenuLoading ? (
                <div>{<ProgressIndicator description="loading menu..." />}</div>
              ) : (
                <Observer>
                  {() => (
                    <Menu
                      theme="dark"
                      mode="inline"
                      defaultSelectedKeys={[mainStore.menuSelectedKey]}
                      defaultOpenKeys={[mainStore.menuOpenKey]}
                      selectedKeys={[mainStore.menuSelectedKey]}
                      onClick={(menu) => {
                        mainStore.menuSelectedKey = menu.keyPath[0];
                        mainStore.menuOpenKey = menu.keyPath[1];
                        console.log("menu clicked", menu);
                        if (menu.key === "8") {
                          //switch to ebendo asset in material usage link
                          if (mainStore.assetContextId === 1) {
                            mainStore.assetContextId = 2;
                            mainStore.assetContextName = "EBENDO";
                          }
                        }
                      }}
                    >
                      {sideMenus}
                      <Menu.Item key="visual-query-builder">
                        <DatabaseOutlined />
                        <Link to="/monthly-performance/query-builder">
                          Query Builder
                        </Link>
                      </Menu.Item>
                    </Menu>
                  )}
                </Observer>
              )}
            </Sider>
            <Layout style={{ flex: 1, minHeight: 0 }}>
              <Header style={{ background: "#fff", padding: 0 }}>
                <North
                  menu={globalMenu}
                  clearselection={handleClearMenuSelection}
                  history={globalHistory}
                />
                <Offline
                  onChange={(args) => {
                    if (args === true) {
                      notification.success({
                        message: `Connected `,
                        description: "successfully connected to the internet",
                        placement: "bottomRight",
                      });
                    } else {
                      notification.warning({
                        message: `Not Connected `,
                        description:
                          "it looks like you're not connected to the internet or temporarily disconnected,please check your internet connection",
                        placement: "bottomRight",
                        icon: <ApiOutlined style={{ color: "red" }} />,
                      });
                    }
                  }}
                ></Offline>

                <MessageBar
                  style={{
                    width: "100%",
                  }}
                  messageBarType={MessageBarType.warning}
                >
                  <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm3">
                        <div className="ms-Grid" dir="ltr">
                          <div className="ms-Grid-row">
                            <div
                              className="ms-Grid-col ms-sm6"
                              style={{ textAlign: "right" }}
                            >
                              Active Workspace Asset:
                            </div>
                            <div
                              className="ms-Grid-col ms-sm6"
                              style={{
                                color: "Red",
                                fontWeight: "bold",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                mainStore.showContextDialog = true;
                              }}
                            >
                              <Tooltip
                                title={` ${mainStore.assetContextName} is current active workspace Asset`}
                              >
                                {" "}
                                <span>{mainStore.assetContextName}</span>
                              </Tooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </MessageBar>
              </Header>
              <Content style={{ display: "flex", flex: 1, minHeight: 0, overflow: "hidden" }}>
                <div className="ms-Grid" dir="ltr" style={{ display: "flex", flex: 1, minHeight: 0 }}>
                  <div className="ms-Grid-row" style={{ flex: 1, minHeight: 0 }}>
                    <Routes>
                      <Route path="/" element={<Login />} />
                      <Route path="/login" element={<Login />} />
                      <Route
                        path="/main/userprofile/settings"
                        element={<PrivateRoute component={userProfileBaseView} />}
                      />
                      <Route
                        path="/main/accounts/users"
                        element={<PrivateRoute component={accountCenterView} />}
                      />
                      <Route
                        path="/main/accounts/permissions"
                        element={<PrivateRoute component={permissionView} />}
                      />
                      <Route
                        path="/productiondata/field-daily-production"
                        element={<PrivateRoute component={fieldDailyProductionView} />}
                      />

                      <Route
                        path="/production/target/"
                        element={<PrivateRoute component={productionTargetBaseView} />}
                      />
                      <Route
                        path="/production/target/commercial"
                        element={<PrivateRoute component={contractBaseView} />}
                      />
                      <Route
                        path="/materials/material-usage"
                        element={<PrivateRoute component={materialBaseView} />}
                      />
                      <Route
                        path="/main/administration/settings"
                        element={<PrivateRoute component={settingsBaseView} />}
                      />
                      <Route
                        path="/monthly-performance/string-production"
                        element={<PrivateRoute component={monthlyPerformanceBaseView} />}
                      />
                      <Route
                        path="/monthly-performance/query-builder"
                        element={<PrivateRoute component={visualQueryBuilderView} />}
                      />
                      <Route
                        path="/visualization/flowstation-capacity-utilization"
                        element={<PrivateRoute component={flowStationVisualizationBaseView} />}
                      />
                      <Route
                        path="/production/workflow/request"
                        element={<PrivateRoute component={requestBaseView} />}
                      />
                      <Route
                        path="/production/workflow/approval"
                        element={<PrivateRoute component={approvalBaseView} />}
                      />
                      <Route
                        path="/production/highlights-lowlights"
                        element={<PrivateRoute component={highLightBaseView} />}
                      />
                      <Route
                        path="/dashboard/production-outlook"
                        element={<PrivateRoute component={outlookDashboard} />}
                      />
                      <Route
                        path="/dashboard/well-performance"
                        element={<PrivateRoute component={wellperformance} />}
                      />
                      <Route
                        path="/dashboard/flowstation-trend"
                        element={<PrivateRoute component={flowStationprodTrendBaseView} />}
                      />

                      <Route
                        path="/dashboard/field-trend"
                        element={<PrivateRoute component={fieldProdTrendBaseView} />}
                      />
                      <Route
                        path="/licence-expired"
                        element={<PrivateRoute component={Expiry} />}
                      />
                      <Route path="*" element={<NotFound />} />
                    </Routes>
                  </div>
                </div>
                <ReportViewer />
                <GlobalLinkBaseView />
              </Content>
              {/* <Footer style={{ textAlign: "center" }}>
                <Text type="danger">
                  An Integrated Oil & Gas Production Digitalization Platform ©
                  {new Date().getFullYear()} Powered by{" "}
                  <a
                    href="http://www.cybersprint.tech"
                    target="_blank"
                    rel="noreferrer"
                  >
                    CyberSprint Technologies
                  </a>
                </Text>
              </Footer> */}
            </Layout>
          </Layout>
        </>
      );
    });

